<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M15.9166 2.3696H15.5034C15.3413 1.74585 14.7802 1.28269 14.1053 1.28269H12.1384C11.7231 0.522885 10.9255 0 10.0002 0C9.07508 0 8.27727 0.523582 7.86198 1.28269H5.89501C5.21967 1.28269 4.65891 1.74574 4.49658 2.3696H4.08373C3.28383 2.3696 2.63464 3.01914 2.63464 3.81857V18.551C2.63464 19.3513 3.28383 20.0001 4.08373 20.0001H15.9166C16.7162 20.0001 17.3657 19.3513 17.3657 18.551V3.81857C17.3656 3.01728 16.7174 2.3696 15.9166 2.3696ZM10.0002 1.40296C10.5754 1.40296 11.0417 1.8696 11.0417 2.44524C11.0417 3.02042 10.5754 3.48671 10.0002 3.48671C9.42494 3.48671 8.9583 3.01972 8.9583 2.44524C8.9583 1.87077 9.42483 1.40296 10.0002 1.40296ZM5.78915 15.29C5.38839 15.29 5.06466 14.9659 5.06466 14.5654C5.06466 14.165 5.38839 13.841 5.78915 13.841C6.19073 13.841 6.51364 14.165 6.51364 14.5654C6.51375 14.9659 6.18933 15.29 5.78915 15.29ZM5.78915 11.6673C5.38839 11.6673 5.06466 11.3432 5.06466 10.9428C5.06466 10.5423 5.38839 10.2183 5.78915 10.2183C6.19073 10.2183 6.51364 10.5423 6.51364 10.9428C6.51375 11.3432 6.18933 11.6673 5.78915 11.6673ZM5.78915 8.04464C5.38839 8.04464 5.06466 7.72022 5.06466 7.32016C5.06466 6.91974 5.38839 6.59567 5.78915 6.59567C6.19073 6.59567 6.51364 6.91974 6.51364 7.32016C6.51375 7.72022 6.18933 8.04464 5.78915 8.04464ZM14.5333 15.29H8.17072C7.76914 15.29 7.44623 14.9659 7.44623 14.5654C7.44623 14.165 7.76926 13.841 8.17072 13.841H14.5333C14.9345 13.841 15.2578 14.165 15.2578 14.5654C15.2579 14.9659 14.9345 15.29 14.5333 15.29ZM14.5333 11.6673H8.17072C7.76914 11.6673 7.44623 11.3432 7.44623 10.9428C7.44623 10.5423 7.76926 10.2183 8.17072 10.2183H14.5333C14.9345 10.2183 15.2578 10.5423 15.2578 10.9428C15.2579 11.3432 14.9345 11.6673 14.5333 11.6673ZM14.5333 8.04464H8.17072C7.76914 8.04464 7.44623 7.72022 7.44623 7.32016C7.44623 6.91974 7.76926 6.59567 8.17072 6.59567H14.5333C14.9345 6.59567 15.2578 6.91974 15.2578 7.32016C15.2579 7.72022 14.9345 8.04464 14.5333 8.04464Z"
        fill="white"
      />
      <ellipse
        cx="15.25"
        cy="15.5833"
        rx="4.58333"
        ry="4.58333"
        fill="#212121"
        fill-opacity="0.75"
      />
      <g clip-path="url(#clip1)">
        <path
          d="M15.25 11.8333C13.1822 11.8333 11.5 13.5154 11.5 15.5833C11.5 17.6511 13.1822 19.3333 15.25 19.3333C17.3178 19.3333 19 17.6511 19 15.5833C19 13.5154 17.3178 11.8333 15.25 11.8333ZM15.5625 15.5833C15.5625 15.7561 15.4228 15.8957 15.25 15.8957H14C13.8272 15.8957 13.6875 15.7561 13.6875 15.5833C13.6875 15.4104 13.8272 15.2708 14 15.2708H14.9375V13.3958C14.9375 13.2229 15.0772 13.0833 15.25 13.0833C15.4228 13.0833 15.5625 13.2229 15.5625 13.3958V15.5833Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1">
        <rect
          width="7.5"
          height="7.5"
          fill="white"
          transform="translate(11.5 11.8333)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'SvgAgenda',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>

<style>

</style>
